import script from "./billDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./billDetail.vue?vue&type=script&setup=true&lang=js"

import "./billDetail.vue?vue&type=style&index=0&id=4340c4ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4340c4ef"]])

export default __exports__